import React from "react";
import { useTranslation } from "react-i18next";
import SimpleSelect from "components/SimpleSelect";
import { IconCopy, IconTrash } from "@tabler/icons-react";
import {
  PROPERTY_RULE_OPERATORS,
  PROPERTY_TEMPLATE_OPERATORS,
} from "features/DynamicTable/consts";
import clsx from "clsx";
import { ColumnSourceEnum, PropertyBrowserNodeOUT } from "api-client";
import PropertyField from "./PropertyField";
import ValuePropertyField from "./ValuePropertyField";

export interface ConditionProps {
  valueProperty: PropertyBrowserNodeOUT | undefined;
  value: string | number;
  property: PropertyBrowserNodeOUT | undefined;
  operator?: string;
  value_source?: string | null;
}

export interface RuleConditionRowProps {
  index: number;
  row: ConditionProps;
  onCopyRow?: () => void;
  onRemoveRow?: () => void | undefined;
  onSelectProperty: (value: PropertyBrowserNodeOUT) => void;
  onSelectOperator: (
    value: string | undefined | number,
    update?: boolean
  ) => void;
  onSelectValue: (value: PropertyBrowserNodeOUT | string) => void;
  onRemoveProperty: () => void;
  onRemoveValue: () => void;
}

const ConditionRow = (props: RuleConditionRowProps) => {
  const { t } = useTranslation();

  const isCurrentSourceTemplate =
    props.row.value_source === ColumnSourceEnum.TemplateVariable;

  const handleSelectOperator = (operator: string | undefined | number) => {
    props.onSelectOperator(operator, true);
  };

  return (
    <div className="flex items-center py-2 gap-2 min-w-[595px] transition group/filterItem w-full">
      <span className="min-w-[40px] text-right text-sm font-semibold">
        {props.index === 0 ? t("rulesEditor.when") : t("rulesEditor.and")}
      </span>
      <PropertyField
        onSelectProperty={props.onSelectProperty}
        onRemoveProperty={props.onRemoveProperty}
        row={props.row}
      />
      <SimpleSelect
        options={
          isCurrentSourceTemplate
            ? PROPERTY_TEMPLATE_OPERATORS
            : PROPERTY_RULE_OPERATORS
        }
        noMargin
        className="!mb-0 !mt-0 min-w-[190px]"
        onChange={handleSelectOperator}
        current={props.row.operator}
      />
      <ValuePropertyField
        row={props.row}
        onRemoveValue={props.onRemoveValue}
        onSelectValue={props.onSelectValue}
        onSelectOperator={props.onSelectOperator}
      />
      <IconCopy
        className="text-indigo-700 hover:text-indigo-900 cursor-pointer min-w-[24px] ml-2"
        size={24}
        onClick={props.onCopyRow}
      />
      <IconTrash
        className={clsx(
          "text-red-700 hover:text-red-900 cursor-pointer transition min-w-[24px]",
          props.onRemoveRow ? "opacity-100" : "opacity-40 !cursor-not-allowed"
        )}
        size={24}
        onClick={props.onRemoveRow}
      />
    </div>
  );
};

export default ConditionRow;
